import { css } from '@emotion/core'
import { ThemeProps } from '@themes/theme'

export const ManageUserButtonStyle = (props:ThemeProps) => css`
  border-radius: 0;
  width: 60px;
  height: 60px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  > img {
    width: 60px;
    height: auto;
    object-fit: cover;
  }
`